export default "__VITE_ASSET__RA6sWyp0__"